// extracted by mini-css-extract-plugin
export default {"link":"link_link__v5BTm","disabled":"link_disabled__42F5d"};